import React, { Fragment, useState, useEffect } from "react";
import axios from "axios";
import Sidebar from "./Sidebar";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
const Upateprice = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  console.log(id);
  const [newprice, setNewprice] = useState();
  const [currentgoldprice, setCurrentgoldprice] = useState([]);

  console.log(newprice);

  useEffect(() => {
    const fetchCurrentPrice = async () => {
      try {
        const response = await axios.get(
          "/goldprice/admin/show"
        );
        setCurrentgoldprice(response.data);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchCurrentPrice();
  }, []);

  // update the current  gold price in database
  const handlePriceUpdate = async (e, id) => {
    if (e) e.preventDefault();
    console.log("Updating price for ID:", id, "New Price:", newprice);
    
    if (!newprice || isNaN(newprice)) {
      toast.error("Please enter a valid numeric price");
      return;
    }

    try {
      await axios.put(`/goldprice/admin/update/${id}`, {
        goldprice: Number(newprice),
      });
      toast.success("Price updated successfully!");
      navigate("/admin/currentprice");
    } catch (error) {
      console.error("Error updating product price:", error);
      toast.error("Failed to update gold price");
    }
  };

  return (
    <div className="flex bg-gray-50 min-h-screen">
      <Sidebar />
      <div className="flex-1 p-8 text-black">
        <div className="max-w-2xl mx-auto bg-white shadow-xl rounded-2xl p-10 border border-gray-100">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 border-b pb-4">
            Update Gold Price
          </h2>
          
          <div className="wrapper my-5 mx-4">
            {currentgoldprice.length > 0 ? (
              currentgoldprice.map((price) => (
                <form 
                    key={price._id} 
                    onSubmit={(e) => handlePriceUpdate(e, price._id)}
                    className="space-y-6"
                >
                  <div>
                    <label
                      htmlFor="goldprice"
                      className="block mb-2 text-sm font-semibold text-gray-700"
                    >
                      Update price per gram (Current: Rs {price.goldprice})
                    </label>

                    <input
                      type="number"
                      id="goldprice"
                      step="0.01"
                      required
                      placeholder={`Current: ${price.goldprice}`}
                      value={newprice || ""}
                      onChange={(e) => setNewprice(e.target.value)}
                      className="block w-full px-4 py-3 bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                    />
                  </div>

                  <div className="flex gap-4">
                      <button
                        type="submit"
                        className="flex-1 py-3 px-6 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-lg shadow-lg transition-transform hover:scale-105 active:scale-95"
                      >
                        Save Changes
                      </button>
                      <button
                        type="button"
                        onClick={() => navigate("/admin/currentprice")}
                        className="py-3 px-6 bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold rounded-lg transition-colors"
                      >
                        Cancel
                      </button>
                  </div>
                </form>
              ))
            ) : (
                <div className="text-center py-10">
                    <p className="text-gray-500 mb-4">No price record found to update.</p>
                    <button 
                        onClick={() => navigate("/admin/currentprice")}
                        className="text-blue-600 hover:underline font-medium"
                    >
                        Go back to add a price
                    </button>
                </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Upateprice;
